/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmptyResponse } from '../../models/empty-response';

export interface AttachmentsControllerAddAttachment$Params {
  entity: 'agreement' | 'asset_management' | 'ddt' | 'delivery' | 'order' | 'order_customer' | 'schedule' | 'ticket' | 'warehouse';
  id: number;
  type: number;
      body: {
'allegato'?: Blob;
}
}

export function attachmentsControllerAddAttachment(http: HttpClient, rootUrl: string, params: AttachmentsControllerAddAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<EmptyResponse>> {
  const rb = new RequestBuilder(rootUrl, attachmentsControllerAddAttachment.PATH, 'put');
  if (params) {
    rb.path('entity', params.entity, {});
    rb.path('id', params.id, {});
    rb.path('type', params.type, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmptyResponse>;
    })
  );
}

attachmentsControllerAddAttachment.PATH = '/attachments/{entity}/{id}/{type}';
